import { DOMAIN_DETAIL } from "../Types/types";

const intialState = {
  menuList: [
    {
      name: "Dashboard",
      path: "/dashboard",
      icon: "grid-dividers.png",
    },
    {
      name: "Jobs",
      path: "/jobs",
      icon: "bag-icon.svg",
    },
    {
      name: "My Assessments",
      path: "/assessments",
      icon: "shield-trust.svg",
    },
    {
      name: "Gappeo Tests",
      path: "/gappeo-tests",
      icon: "gappeo-test-icon.svg",
    },
    {
      name: "My Tests",
      path: "/my-tests",
      icon: "my-test-icon.svg",
    },
    {
      name: "My Questions",
      path: "/my-questions",
      icon: "my-questions-icon.svg",
    },
    // {
    //   name: "Voice interviews",
    //   path: "/voice-interviews",
    //   icon: "circle-microphone.svg",
    // },
    {
      name: "Reports",
      icon: "analytics.svg",
      subMenu: [
        { name: "Assessments", path: "/reports" },
        { name: "Voice interview", path: "/voice-interviews-report" },
        { name: "Video interview", path: "/video-interviews-report" },
      ]
    },
    // {
    //   name: "Video interviews",
    //   path: "/video-interviews",
    //   icon: "camera-movie.svg",
    // },
    // {
    //   name: "Reports",
    //   path: "/reports",
    //   icon: "analytics.svg",
    // },
    // {
    //   name: "Settings",
    //   path: "/settings",
    //   icon: "settings.svg",
    // },
  ],
  adminMenuList: [
    // {
    //   name: "Dashboard",
    //   path: "/dashboard",
    //   icon: "grid-dividers.svg",
    // },
    // {
    //   name: "Jobs",
    //   path: "/jobs",
    //   icon: "bag-icon.svg",
    // },
    // {
    //   name: "Voice interviews",
    //   path: "/voice-interviews",
    //   icon: "circle-microphone.svg",
    // },
    {
      name: "Assessments",
      icon: "shield-trust.svg",
      subMenu: [
        { name: "My Assessments", path: "/assessments" },
        { name: "Gappeo Tests", path: "/gappeo-tests" },
        { name: "My Tests", path: "/my-tests" },
        { name: "My Questions", path: "/my-questions" }
      ]
    },
    // {
    //   name: "Video interviews",
    //   path: "/video-interviews",
    //   icon: "camera-movie.svg",
    // },
    // {
    //   name: "Reports",
    //   path: "/reports",
    //   icon: "analytics.svg",
    // },
    {
      name: "Users",
      path: "/users",
      icon: "users.svg",
    }
    // {
    //   name: "Settings",
    //   path: "/settings",
    //   icon: "settings.svg",
    // },
  ],
};

export default function layoutReducer(state = intialState, action) {
  let stateCopy = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case DOMAIN_DETAIL:
      stateCopy.domainDetails = action.payload;
      localStorage.setItem("domainDetails", JSON.stringify(action.payload));
      return stateCopy;
    default:
      return stateCopy;
  }
}
